import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { AffCode } from 'src/app/affcode/shared/affcode.model';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';

@Component({
  selector: 'wl-ecom-item-edit-restrictions',
  templateUrl: './ecom-item-edit-restrictions.component.html',
  styleUrls: ['./ecom-item-edit-restrictions.component.less'],
    standalone: false
})
export class EComItemEditRestrictionsComponent implements OnInit {
  @Input() eCommerceItem: EcomItemDto;
  allAffCodes: string[] = [];
  affCodeSearchResults: string[] = [];
  selectedAffCodes: string[] = [];
  needAffCodes = false;

  constructor(private _affcodeService: AffCodeService) {}

  ngOnInit(): void {
    this._affcodeService.getAllAffCodes().then((data) => {
      this.allAffCodes = data?.map((x) => x.AffCode);
      if (this.needAffCodes) {
        this.selectedAffCodes = this.eCommerceItem.RestrictToAffCodes || [];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem) {
      if (this.allAffCodes.length) {
        this.selectedAffCodes = this.eCommerceItem.RestrictToAffCodes || [];
      } else {
        this.needAffCodes = true;
      }
    }
  }
  searchAffCodes(searchEvent: any) {
    this.affCodeSearchResults = this.allAffCodes
      ?.filter((ac) => ac.toLowerCase().includes(searchEvent.query?.toLowerCase()))
      .filter((x) => !this.selectedAffCodes?.find((y) => x === y));
  }

  public affCodeSelected() {
    this.eCommerceItem.RestrictToAffCodes = this.selectedAffCodes;
  }
}
